import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { MarginItem } from '../../types';
import { exchangeMarginsApi } from '../services';

export interface MarginListState {
  isLoading: boolean;
  requestInProgress: boolean;
  margins?: MarginItem[];
  pagination?: Pagination;
  sort?: {
    sortProp: string;
    sortDir: string;
  };
  defaultMargin?: MarginItem;
  errorsList?: string;
}

const initialState: MarginListState = {
  isLoading: false,
  requestInProgress: false,
  sort: undefined,
};

export const marginListSlice = createSlice({
  name: 'marginList',
  initialState,
  reducers: {
    clearMarginListState: (state) => {
      state.isLoading = true;
      state.requestInProgress = false;
      state.margins = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exchangeMarginsApi.endpoints.getMargins.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.getMargins.matchRejected,
      (state, action: any) => {
        state.margins = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.getMargins.matchFulfilled,
      (state, action: PayloadAction<Response<MarginItem>>) => {
        state.margins = action.payload.data.edges.map((item) => ({
          ...item.node,
          riskScoreRangeId: '',
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.updateDefaultMargin.matchFulfilled,
      (state, action: PayloadAction<{ data: MarginItem }>) => {
        const nextMargins = state.margins?.map((item) => {
          let result = { ...item };

          if (result.id === action.payload.data.id) {
            result = action.payload.data;
          }

          return result;
        });

        state.margins = nextMargins;
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.getDefaultMargin.matchFulfilled,
      (state, action: PayloadAction<{ data: MarginItem }>) => {
        state.defaultMargin = action.payload.data;
      },
    );
  },
});

export const { clearMarginListState } = marginListSlice.actions;

export default marginListSlice.reducer;
